import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

export async function checkVoiceRecording(groupId: string): Promise<boolean> {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (!inputPanel) {
    return true;
  }

  if (!inputPanel.voice.isRecording && !inputPanel.voice.isPreviewMode) {
    return true;
  }

  const confirmResult = await Tasks.app.showConfirm({
    text: t('common_voice_message_cancel_confirmation'),
    primaryText: t('common_ok'),
    secondaryText: t('cancel'),
  });

  if (confirmResult) {
    inputPanel.voice.reset();
    return true;
  }

  return false;
}
